module.exports = __webpack_public_path__ + "assets/img/ecg-detail-back-banner2.d71d4db2.png";